export default "__VITE_ASSET__CzyMC3$P__"